import { EarlyAccessBanner } from '@components/hub/EarlyAccessBanner';
import { UsernamePopup } from '@components/hub/player/UsernamePopup';
import { HubTutorial } from '@components/tutorial/HubTutorial';
import { Capsules } from '@components/hub/capsules/Capsules';
import { RateGame } from '@components/hub/player/RateGame';
import { Patchnotes } from '@components/hub/Patchnotes';
import { Allies } from '@components/hub/allies/Allies';
import { Guide } from '@components/hub/guide/Guide';
import { Player } from '@components/hub/Player';
import { Quests } from '@components/hub/Quests';

export function Hub() {
  return (
    <div className="flex flex-col h-full">
      <UsernamePopup />
      <HubTutorial />

      <Patchnotes />
      <Player />

      <div className="flex-1 overflow-y-auto">
        <EarlyAccessBanner />
        <RateGame />
        <Capsules />
        <Guide />
        <Quests />
        <Allies />
      </div>
    </div>
  );
}